import React from 'react'
import ProfilePicturesPanel from 'app/components/ProfilePicturesPanel'
import ApiPanel from './ApiPanel'

export default (props) => {
  const { ApiPanelProp, emptyContent } = props
  const onSuccess = (values) => (
    <ProfilePicturesPanel
      title={ApiPanelProp.title}
      items={values.items}
      remainingCount={values.remainingCount}
      emptyContent={emptyContent}
      onItemClick={ApiPanelProp.onItemClick}
      link={ApiPanelProp.link}
      withCrmField={ApiPanelProp.withCrmField || false}
      subscribersPageSection={ApiPanelProp.subscribersPageSection}
      teamMembersPageSection={ApiPanelProp.teamMembersPageSection}
    />
  )

  return <ApiPanel {...ApiPanelProp} onSuccess={onSuccess} />
}
